// Vendors
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const LANDING_OPTIONS_MODAL_COMPONENT_PROPS = {
  'blocked': true,
  'contentScrollArias': {
    'aria-label': 'Content Scroll',
  },
  'data-testid': 'layout-modal-component',
  'open': true,
  'variant': VARIANTS.ModalContainerVariantType.DEFAULT,
};

export { LANDING_OPTIONS_MODAL_COMPONENT_PROPS };
